import { useState, useEffect } from "react";
import TurnstileWidget from "../components/TurnstileWidget";
import api from "../api";
import zxcvbn from "zxcvbn";
import PasswordStrengthMeter from "../components/PasswordStrengthMeter";
import PasswordPolicyChecklist from "../components/PasswordPolicyChecklist";

import "./home.css";

export default function Register() {
  const [username, setUsername] = useState("");
  const [email, setEmail]       = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading]   = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [turnstileToken, setTurnstileToken] = useState("");
  // neue optionale Felder (Twitch Pflicht)
  const [firstName, setFirstName] = useState("");
  const [twitchName, setTwitchName] = useState("");
  const [tiktokName, setTiktokName] = useState("");
  const [youtubeName, setYoutubeName] = useState("");
  const [instagramName, setInstagramName] = useState("");
  const [discoverySource, setDiscoverySource] = useState("");
  const [consent, setConsent] = useState(false);
  const [referrer, setReferrer] = useState(null); // raw value from URL/localStorage
  const [referrerDisplay, setReferrerDisplay] = useState(null); // resolved display name

  const score = password ? zxcvbn(password, [username, email]).score : 0;

  // einfache clientseitige Vorprüfung (Server prüft final!)
  const hasLower   = /[a-z]/.test(password);
  const hasUpper   = /[A-Z]/.test(password);
  const hasDigit   = /[0-9]/.test(password);
  const hasSpecial = /[^A-Za-z0-9]/.test(password);
  const noSpaces   = !/\s/.test(password);
  const lenOK      = (password?.length || 0) >= 10;

  const clientOK   = lenOK && hasLower && hasUpper && hasDigit && hasSpecial && noSpaces && score >= 3 && !!twitchName && consent === true;

  const handleRegister = async () => {
    if (!turnstileToken) {
      alert("Bitte Captcha bestätigen.");
      return;
    }
    if (!twitchName) {
      alert("Bitte gib deinen Twitch‑Namen an (Pflichtfeld).");
      return;
    }
    if (!consent) {
      alert("Bitte stimme AGB und Datenschutz zu.");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/register", {
        username,
        email,
        password,
        turnstileToken,
        firstName,
        twitchName,
        tiktokName,
        youtubeName,
        instagramName,
        discoverySource,
        consent,
        ref: referrer || undefined,
      });
      alert("Registriert! Dein Account wird geprüft.");
      setUsername(""); setEmail(""); setPassword(""); setTurnstileToken("");
      setFirstName(""); setTwitchName(""); setTiktokName(""); setYoutubeName(""); setInstagramName(""); setDiscoverySource(""); setConsent(false); setReferrer(null);
    } catch (e) {
      const r = e.response?.data;
      alert(r?.reasons?.join("\n") || r?.error || "Fehler bei der Registrierung");
    } finally {
      setLoading(false);
    }
  };

  // referral param aus URL lesen
  useEffect(() => {
    let active = true;
    try {
      const sp = new URLSearchParams(window.location.search);
      let r = sp.get('ref');
      if (!r) r = localStorage.getItem('apn_ref');
      if (r) {
        setReferrer(r);
        // Versuche DisplayName vom Server zu holen
        api.get('/auth/resolve-ref', { params: { ref: r } })
          .then(res => {
            if (!active) return;
            const dn = res?.data?.user?.displayName || res?.data?.user?.username;
            if (dn) setReferrerDisplay(dn);
          })
          .catch(() => { /* Ignoriere Fehler, behalte Rohwert */ });
      }
    } catch {}
    return () => { active = false; };
  }, []);

  return (
    <div className="home-page" style={{width:'100vw',margin:0,padding:0}}>
      <section style={{width:'100vw', margin:0, padding:0, position:'relative', left:'-120px'}}>
        <h2 className="hero-title" style={{ textAlign:'center', margin:'0 0 8px' }}>Zur Warteliste</h2>
        <p className="hero-desc" style={{ margin:'0 auto 24px', textAlign:'center', maxWidth:760 }}>
          Werde Teil des AP-Network!<br/>
          Registriere dich jetzt und profitiere von exklusiven Vorteilen.
        </p>
      </section>
      {/* REGISTRATION FORM */}
  <section style={{width:'100vw',margin:0,padding:0}}>
        <form className="highlight-card" style={{gap:18, padding:32}} onSubmit={e=>{e.preventDefault(); handleRegister();}}>
          <h2 className="highlight-title" style={{marginBottom:8}}>Registrierung</h2>
          {referrer && (
            <div style={{fontSize:12, padding:'8px 12px', border:'1px solid rgba(50,205,137,0.5)', background:'rgba(50,205,137,0.12)', borderRadius:8}}>
              Geworben durch: <strong>{referrerDisplay || 'Lädt…'}</strong>
            </div>
          )}
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
            <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
              <label style={{ fontSize:12 }}>Benutzername <span style={{ color:'#e33' }}>*</span></label>
              <input aria-required="true" className="hero-btn-secondary" style={{padding:"12px 18px", fontSize:"1rem", borderColor: username? undefined : '#e66' }} placeholder="Benutzername (wird zunächst auch als Anzeigename gesetzt)" value={username} onChange={e=>setUsername(e.target.value)} />
            </div>
            <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
              <label style={{ fontSize:12 }}>E‑Mail <span style={{ color:'#e33' }}>*</span></label>
              <input aria-required="true" className="hero-btn-secondary" style={{padding:"12px 18px", fontSize:"1rem", borderColor: (email && /.+@.+\..+/.test(email)) ? undefined : '#e66' }} placeholder="E‑Mail" value={email} onChange={e=>setEmail(e.target.value)} />
            </div>
          </div>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
            <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
              <label style={{ fontSize:12 }}>Vorname (optional)</label>
              <input className="hero-btn-secondary" style={{padding:"12px 18px", fontSize:"1rem"}} placeholder="Vorname (optional)" value={firstName} onChange={e=>setFirstName(e.target.value)} />
            </div>
            <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
              <label style={{ fontSize:12 }}>Twitch‑Name <span style={{ color:'#e33' }}>*</span></label>
              <input aria-required="true" className="hero-btn-secondary" style={{padding:"12px 18px", fontSize:"1rem", borderColor: twitchName? undefined : '#e66' }} placeholder="Twitch‑Name (Pflicht)" value={twitchName} onChange={e=>setTwitchName(e.target.value)} />
            </div>
          </div>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
            <input className="hero-btn-secondary" style={{padding:"12px 18px", fontSize:"1rem"}} placeholder="TikTok (optional)" value={tiktokName} onChange={e=>setTiktokName(e.target.value)} />
            <input className="hero-btn-secondary" style={{padding:"12px 18px", fontSize:"1rem"}} placeholder="YouTube (optional)" value={youtubeName} onChange={e=>setYoutubeName(e.target.value)} />
          </div>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
            <input className="hero-btn-secondary" style={{padding:"12px 18px", fontSize:"1rem"}} placeholder="Instagram (optional)" value={instagramName} onChange={e=>setInstagramName(e.target.value)} />
            <input className="hero-btn-secondary" style={{padding:"12px 18px", fontSize:"1rem"}} placeholder="Wie auf uns aufmerksam geworden? (optional)" value={discoverySource} onChange={e=>setDiscoverySource(e.target.value)} />
          </div>
          <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
            <label style={{ fontSize:12 }}>Passwort <span style={{ color:'#e33' }}>*</span></label>
            <div style={{position:'relative'}}>
              <input aria-required="true" className="hero-btn-secondary" style={{padding:"12px 18px", fontSize:"1rem", width:'100%', borderColor: password? undefined : '#e66' }} type={showPassword ? "text" : "password"} placeholder="Passwort" value={password} onChange={e=>setPassword(e.target.value)} />
            <button
              type="button"
              aria-label={showPassword ? "Passwort verbergen" : "Passwort anzeigen"}
              onClick={()=>setShowPassword(v=>!v)}
              style={{
                position:'absolute',
                right:8,
                top:'50%',
                transform:'translateY(-50%)',
                background:'none',
                border:0,
                cursor:'pointer',
                color:'#32CD89',
                fontSize:'1.3em',
                padding:'4px 8px',
                lineHeight:1
              }}
            >
              {showPassword ? "🙈" : "👁️"}
            </button>
            </div>
          </div>

          <PasswordStrengthMeter password={password} userInputs={[username, email]} />
          <PasswordPolicyChecklist password={password} />

          <label style={{ display:'flex', alignItems:'flex-start', gap:10, fontSize:14, lineHeight:1.4, padding:10, border:'1px solid', borderColor: consent ? 'transparent' : '#e66', borderRadius:8 }}>
            <input aria-required="true" type="checkbox" checked={consent} onChange={e=>setConsent(e.target.checked)} />
            <span>
              Ich stimme den <a href="/agb" target="_blank" rel="noreferrer">AGB</a> und der <a href="/datenschutz" target="_blank" rel="noreferrer">Datenschutzerklärung</a> zu <span style={{ color:'#e33' }}>*</span>.
            </span>
          </label>

          {/* Cloudflare Turnstile Widget */}
          <TurnstileWidget sitekey={(import.meta.env.VITE_TURNSTILE_SITEKEY || "0x4AAAAAAB2codhfYjkyNj0I")} onVerify={setTurnstileToken} />

          <button type="submit" className="hero-btn-primary" style={{marginTop:8}} disabled={!clientOK || loading || !turnstileToken}>
            {loading ? "Sende ..." : "Registrieren"}
          </button>
          {(!clientOK || !turnstileToken) && (
            <div style={{marginTop:12, fontSize:12, lineHeight:1.5, background:'rgba(255,255,255,0.06)', padding:'10px 12px', borderRadius:8, border:'1px solid rgba(255,255,255,0.15)'}}>
              <strong>Fehlende Voraussetzungen:</strong>
              <ul style={{margin:'6px 0 0', paddingLeft:18}}>
                {!turnstileToken && <li>Captcha noch nicht bestätigt.</li>}
                {!(password?.length >= 10) && <li>Mindestens 10 Zeichen.</li>}
                {!/[a-z]/.test(password) && <li>Kleinbuchstabe fehlt.</li>}
                {!/[A-Z]/.test(password) && <li>Großbuchstabe fehlt.</li>}
                {!/[0-9]/.test(password) && <li>Ziffer fehlt.</li>}
                {!/[^A-Za-z0-9]/.test(password) && <li>Sonderzeichen fehlt.</li>}
                {/\s/.test(password) && <li>Keine Leerzeichen erlaubt.</li>}
                {(password && zxcvbn(password, [username, email]).score < 3) && <li>Passwort‑Stärke zu niedrig.</li>}
                {!twitchName && <li>Twitch‑Name erforderlich.</li>}
                {!consent && <li>AGB / Datenschutz Zustimmung fehlt.</li>}
              </ul>
            </div>
          )}
          <div style={{fontSize:12, opacity:.8, marginTop:8}}>
            Hinweis: Das System prüft zusätzlich serverseitig die Passwort-Policy, deine Zustimmung sowie die Captcha-Lösung.
          </div>
        </form>
      </section>

      {/* CTA */}
      <section className="cta-section" style={{width:'100%',margin:0,padding:0}}>
        <div style={{width:'100%',margin:0,padding:0}}>
          <h2 className="cta-title">Schon registriert?</h2>
          <p className="cta-desc">Du hast bereits einen Account? Dann kannst du dich hier anmelden.</p>
          <a href="/login" className="cta-btn">Zum Login</a>
        </div>
      </section>
    </div>
  );
}
